export const errfs: Record<
  string,
  {
    label_it: string;
    label_en: string;
    desc_it: string;
    desc_en: string;
  }
> = {
  ERRFS_NIHIL: {
    label_it: "---",
    label_en: "---",
    desc_it: "---",
    desc_en: "---",
  },
  ERRFS_SIC0: {
    label_it: "SC0",
    label_en: "SC0",
    desc_it: "SICUREZZA 0",
    desc_en: "SICUREZZA 0",
  },
  ERRFS_SIC1: {
    label_it: "SC1",
    label_en: "SC1",
    desc_it: "SICUREZZA 1",
    desc_en: "SICUREZZA 1",
  },
  ERRFS_EM: {
    label_it: "EM",
    label_en: "EM",
    desc_it: "EMERGENZA",
    desc_en: "EMERGENZA",
  },
  ERRFS_TM: {
    label_it: "TM",
    label_en: "TM",
    desc_it: "TERMICA",
    desc_en: "TERMICA",
  },
  ERRFS_SIC2: {
    label_it: "SC2",
    label_en: "SC2",
    desc_it: "SICUREZZA 2",
    desc_en: "SICUREZZA 2",
  },
  ERRFS_RIF: {
    label_it: "RIF",
    label_en: "RIF",
    desc_it: "RIFASAMENTO",
    desc_en: "RIFASAMENTO",
  },
  ERRFS_EA3_STAZ: {
    label_it: "A3 L0",
    label_en: "A3 L0",
    desc_it: "EMENDAMENTO A3 LIVELLO 0",
    desc_en: "EMENDAMENTO A3 LIVELLO 0",
  },
  ERRFS_MAN: {
    label_it: "MAN",
    label_en: "MAN",
    desc_it: "MANUTENZIONE",
    desc_en: "MANUTENZIONE",
  },
  ERRFS_EA3: {
    label_it: "A3",
    label_en: "A3",
    desc_it: "EMENDAMENTO A3",
    desc_en: "EMENDAMENTO A3",
  },
  ERRFS_RSRD: {
    label_it: "RSRD",
    label_en: "RSRD",
    desc_it: "RIFASATORI SALITA DISCESA",
    desc_en: "RIFASATORE SALITA DISCESA",
  },
  ERRFS_SCONOSCIUTO: {
    label_it: "GEN",
    label_en: "GEN",
    desc_it: "SCONOSCIUTO",
    desc_en: "SCONOSCIUTO",
  },
  ERRFS_DOORS_MOV: {
    label_it: "DOOR M",
    label_en: "DOOR M",
    desc_it: "ERRORE PORTE CON CABINA IN MOVIMENTO",
    desc_en: "ERRORE PORTE CON CABINA IN MOVIMENTO",
  },
  ERRFS_FRENO1_ADH: {
    label_it: "F1 ADH",
    label_en: "F1 ADH",
    desc_it: "ERRORE FRENO 1 INCOLLATO",
    desc_en: "ERRORE FRENO 1 INCOLLATO",
  },
  ERRFS_FRENO1_BRK: {
    label_it: "F1 BRK",
    label_en: "F1 BRK",
    desc_it: "ERRORE FRENO 1 ROTTO",
    desc_en: "ERRORE FRENO 1 ROTTO",
  },
  ERRFS_FRENO2_ADH: {
    label_it: "F2 ADH",
    label_en: "F2 ADH",
    desc_it: "ERRORE FRENO 2 INCOLLATO",
    desc_en: "ERRORE FRENO 2 INCOLLATO",
  },
  ERRFS_FRENO2_BRK: {
    label_it: "F2 BRK",
    label_en: "F2 BRK",
    desc_it: "ERRORE FRENO 2 ROTTO",
    desc_en: "ERRORE FRENO 2 ROTTO",
  },
  ERRFS_DAYS_MAX: {
    label_it: "MAX D",
    label_en: "MAX D",
    desc_it: "SUPERAMENTO GIORNI MASSIMI DI FUNZIONAMENTO",
    desc_en: "SUPERAMENTO GIORNI MASSIMI DI FUNZIONAMENTO",
  },
  ERRFS_CORSE_MAX: {
    label_it: "MAX C",
    label_en: "MAX C",
    desc_it: "SUPERAMENTO CORSE MASSIME DI FUNZIONAMENTO",
    desc_en: "SUPERAMENTO CORSE MASSIME DI FUNZIONAMENTO",
  },
  ERRFS_UCM: {
    label_it: "UCM",
    label_en: "UCM",
    desc_it: "CABINA FUORI PIANO",
    desc_en: "CABINA FUORI PIANO",
  },
  ERRFS_CAN_CABINA: {
    label_it: "COM T",
    label_en: "COM T",
    desc_it: "ERRORE COMUNICAZIONE SERIALE CON SCHEDA TETTO",
    desc_en: "ERRORE COMUNICAZIONE SERIALE CON SCHEDA TETTO",
  },
  ERRFS_CAN_FOSSA: {
    label_it: "COM F",
    label_en: "COM F",
    desc_it: "ERRORE COMUNICAZIONE SERIALE CON SCHEDA FOSSA",
    desc_en: "ERRORE COMUNICAZIONE SERIALE CON SCHEDA FOSSA",
  },
  ERRFS_PP: {
    label_it: "PP",
    label_en: "PP",
    desc_it: "ACCESSO IN FOSSA",
    desc_en: "ACCESSO IN FOSSA",
  },
  ERRFS_PP4: {
    label_it: "PP4",
    label_en: "PP4",
    desc_it: "ACCESSO AL VANO",
    desc_en: "ACCESSO AL VANO",
  },
  ERRFS_MFT: {
    label_it: "MFT",
    label_en: "MFT",
    desc_it: "MANUTENZIONE FOSSA TESTA",
    desc_en: "MANUTENZIONE FOSSA TESTA",
  },
  ERRFS_MFOSSA: {
    label_it: "MF",
    label_en: "MF",
    desc_it: "MANUTENZIONE FOSSA",
    desc_en: "MANUTENZIONE FOSSA",
  },
  ERRFS_MTESTA: {
    label_it: "MT",
    label_en: "MT",
    desc_it: "MANUTENZIONE TESTA",
    desc_en: "MANUTENZIONE TESTA",
  },
  ERRFS_MQUADRO: {
    label_it: "MQ",
    label_en: "MQ",
    desc_it: "MANUTENZIONE QUADRO",
    desc_en: "MANUTENZIONE QUADR",
  },
  ERRFS_EEPROM: {
    label_it: "RAM",
    label_en: "RAM",
    desc_it: "ERRORE LETTURA MEMORIA",
    desc_en: "ERRORE LETTURA MEMORIA",
  },
  ERRFS_PROGRAM: {
    label_it: "CONF",
    label_en: "CONF",
    desc_it: "CONFIGURAZIONE PARAMETRI O PIN",
    desc_en: "CONFIGURAZIONE PARAMETRI O PIN",
  },
  ERRFS_PATT: {
    label_it: "PATT",
    label_en: "PATT",
    desc_it: "PATTINO",
    desc_en: "PATTINO",
  },
  ERRFS_NORMA81_KM81: {
    label_it: "C P K81",
    label_en: "C P K81",
    desc_it: "ERRORE RELE CONTROLLO PONTI",
    desc_en: "ERRORE RELE CONTROLLO PONTI",
  },
  ERRFS_NORMA81_SC4: {
    label_it: "C P SC4",
    label_en: "C P SC4",
    desc_it: "ERRORE PORTE DURANTE CONTROLLO PONTI",
    desc_en: "ERRORE PORTE DURANTE CONTROLLO PONTI",
  },
  ERRFS_NORMA81_SC5: {
    label_it: "C P SC5",
    label_en: "C P SC5",
    desc_it: "ERRORE PORTE DURANTE CONTROLLO PONTI",
    desc_en: "ERRORE PORTE DURANTE CONTROLLO PONTI",
  },
  ERRFS_FCAFCC: {
    label_it: "FCAFCC",
    label_en: "FCAFCC",
    desc_it: "FINE CORSA APERTURA E FINE CORSA CHIUSURA",
    desc_en: "FINE CORSA APERTURA E FINE CORSA CHIUSURA",
  },
  ERRFS_MONTAGGIO: {
    label_it: "MONT",
    label_en: "MONT",
    desc_it: "MONTAGGIO",
    desc_en: "MONTAGGIO",
  },
  ERRFS_EA3FB: {
    label_it: "A3 F",
    label_en: "A3 F",
    desc_it: "ERRORE FEEDBACK DURANTE EMENDAMENTO A3",
    desc_en: "ERRORE FEEDBACK DURANTE EMENDAMENTO A3",
  },
  ERRFS_INIT: {
    label_it: "INIT",
    label_en: "INIT",
    desc_it: "START SCHEDA QUADRO",
    desc_en: "START SCHEDA QUADRO",
  },
  ERRFS_RESET: {
    label_it: "RST",
    label_en: "RST",
    desc_it: "RESET SCHEDA QUADRO",
    desc_en: "RESET SCHEDA QUADRO",
  },
  ERRFS_RS: {
    label_it: "RS",
    label_en: "RS",
    desc_it: "RIFASATORE SALITA",
    desc_en: "RIFASATORE SALITA",
  },
  ERRFS_RD: {
    label_it: "RD",
    label_en: "RD",
    desc_it: "RIFASATORE DISCESA",
    desc_en: "RIFASATORE DISCESA",
  },
  ERRFS_RIPESC_PA: {
    label_it: "LVL PA",
    label_en: "LVL PA",
    desc_it: "LIVELLAMENTO A PORTE APERTE",
    desc_en: "LIVELLAMENTO A PORTE APERTE",
  },
  ERRFS_RIPESC_TIMEOUT: {
    label_it: "LVL TMT",
    label_en: "LVL TMT",
    desc_it: "TIMEOUT LIVELLAMENTO",
    desc_en: "TIMEOUT LIVELLAMENTO",
  },
  ERRFS_RIPESC_MAX: {
    label_it: "LVL MAX",
    label_en: "LVL MAX",
    desc_it: "NUMERO DI LIVELLAMENTO MASSIMO",
    desc_en: "NUMERO DI LIVELLAMENTO MASSIMO",
  },
  ERRFS_DOORS_TMOP: {
    label_it: "TMOP",
    label_en: "TMOP",
    desc_it: "TERMICO OPERATORE",
    desc_en: "TERMICO OPERATORE",
  },
  ERRFS_DOORS_FERMO: {
    label_it: "DOOR F",
    label_en: "DOOR F",
    desc_it: "ERRORE PORTE A CABINA FERMA",
    desc_en: "ERRORE PORTE A CABINA FERMA",
  },
  ERRFS_PARAM: {
    label_it: "PARAM",
    label_en: "PARAM",
    desc_it: "ERRORE LETTURA PARAMETRI",
    desc_en: "ERRORE LETTURA PARAMETRI",
  },
  ERRFS_FW1: {
    label_it: "FW1",
    label_en: "FW1",
    desc_it: "TEST SCHEDA",
    desc_en: "TEST SCHEDA",
  },
  ERRFS_FW2: {
    label_it: "FW2",
    label_en: "FW2",
    desc_it: "TEST SCHEDA",
    desc_en: "TEST SCHEDA",
  },
  ERRFS_FW3: {
    label_it: "FW3",
    label_en: "FW3",
    desc_it: "TEST SCHEDA",
    desc_en: "TEST SCHEDA",
  },
  ERRFS_FW4: {
    label_it: "FW4",
    label_en: "FW4",
    desc_it: "TEST SCHEDA",
    desc_en: "TEST SCHEDA",
  },
  ERRFS_FW5: {
    label_it: "FW5",
    label_en: "FW5",
    desc_it: "TEST SCHEDA",
    desc_en: "TEST SCHEDA",
  },
  ERRFS_FW6: {
    label_it: "FW6",
    label_en: "FW6",
    desc_it: "TEST SCHEDA",
    desc_en: "TEST SCHEDA",
  },
  ERRFS_FW7: {
    label_it: "FW7",
    label_en: "FW7",
    desc_it: "TEST SCHEDA",
    desc_en: "TEST SCHEDA",
  },
  ERRFS_FW10: {
    label_it: "FW10",
    label_en: "FW10",
    desc_it: "TEST SCHEDA",
    desc_en: "TEST SCHEDA",
  },
  ERRFS_TCM_START: {
    label_it: "TCM S",
    label_en: "TCM S",
    desc_it: "TEMPO CORSA MASSIMA CON CABINA AL PIANO INIZIALE",
    desc_en: "TEMPO CORSA MASSIMA CON CABINA AL PIANO INIZIALE",
  },
  ERRFS_TCM_RUN: {
    label_it: "TCM R",
    label_en: "TCM R",
    desc_it: "TEMPO CORSA MASSIMA CON CABINA IN MOVIMENTO",
    desc_en: "TEMPO CORSA MASSIMA CON CABINA IN MOVIMENTO",
  },
  ERRFS_SIGARI: {
    label_it: "SIGAR",
    label_en: "SIGAR",
    desc_it: "ERRORE CONTEGGIO MAGNETI",
    desc_en: "ERRORE CONTEGGIO MAGNETI",
  },
  ERRFS_EA3_V1: {
    label_it: "A3 V1",
    label_en: "A3 V1",
    desc_it: "ERRORE EMENDAMENTO A3 VALVOLA 1",
    desc_en: "ERRORE EMENDAMENTO A3 VALVOLA 1",
  },
  ERRFS_EA3_V2: {
    label_it: "A3 V2",
    label_en: "A3 V2",
    desc_it: "ERRORE EMENDAMENTO A3 VALVOLA 2",
    desc_en: "ERRORE EMENDAMENTO A3 VALVOLA 2",
  },
  ERRFS_CODE1: {
    label_it: "CODE1",
    label_en: "CODE1",
    desc_it: "ERRORE LETTURA CODICE 1",
    desc_en: "ERRORE LETTURA CODICE 1",
  },
  ERRFS_CODE2: {
    label_it: "CODE2",
    label_en: "CODE2",
    desc_it: "ERRORE LETTURA CODICE 2",
    desc_en: "ERRORE LETTURA CODICE 2",
  },
  ERRFS_INIT_CABINA: {
    label_it: "TETTO S",
    label_en: "TETTO S",
    desc_it: "ERRORE SINCRONIZZAZIONE INIZIALE CON LA SCHEDA TETTO",
    desc_en: "ERRORE SINCRONIZZAZIONE INIZIALE CON LA SCHEDA TETTO",
  },
  ERRFS_INIT_FOSSA: {
    label_it: "FOSSA S",
    label_en: "FOSSA S",
    desc_it: "ERRORE SINCRONIZZAZIONE INIZIALE CON LA SCHEDA FOSSA",
    desc_en: "ERRORE SINCRONIZZAZIONE INIZIALE CON LA SCHEDA FOSSA",
  },
  ERRFS_RELE_BROKEN: {
    label_it: "K BROK",
    label_en: "K BROK",
    desc_it: "RELE ROTTO",
    desc_en: "RELE ROTTO",
  },
  ERRFS_RELE_ADHESION: {
    label_it: "K ADH",
    label_en: "K ADH",
    desc_it: "RELE INCOLLATO",
    desc_en: "RELE INCOLLATO",
  },
  ERRFS_GENERICO: {
    label_it: "GEN",
    label_en: "GEN",
    desc_it: "ERRORE SCONOSCIUTO",
    desc_en: "ERRORE SCONOSCIUTO",
  },
};
